<template>
    <div class="admin-course-container">
        <PreLoader v-if="isLoading"/>

        <v-form @submit.prevent="submit" ref="form">
            <h3 style="margin-bottom: 12px">{{isEdit ? $t('editCourse') : $t('addCourse')}}</h3>
            <div>
                <v-text-field :rules="required" v-model="course.title" outlined dense :label="$t('russian')"/>
            </div>
            <div>
                <v-text-field :rules="required" v-model.trim="course.courseTitleKG" outlined dense :label="$t('kyrgyz')"/>
            </div>
            <div>
                <v-text-field :rules="required" v-model.trim="course.code" outlined dense :label="$t('english')"/>
            </div>
            <v-select :items="classTypes" item-text="title" item-value="type" outlined dense
                      :label="$t('classes')" v-model="course.classType"/>
            <div class="form-footer">
                <div class="btn-actions">
                    <v-btn color="red" @click="$emit('close')">{{ $t('cancel') }}</v-btn>
                    <v-btn type="submit" color="green">{{ $t('save') }}</v-btn>
                </div>
            </div>
        </v-form>
    </div>
</template>

<script>
import { AdminCourseService } from '@/_services/admin-course.service'
import PreLoader from '@/components/preloader/PreLoader'
const adminCourseService = new AdminCourseService()

export default {
  name: 'AddCourse',
  components: {
    PreLoader
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    editCourse: {
      type: Object
    },
    classTypes: Array
  },
  data: () => ({
    required: [v => !!v || 'Обязательное поле'],
    isLoading: false,
    course: {
      title: '',
      code: '',
      courseTitleKG: '',
      classType: ''
    }
  }),
  created () {
    this.required = [v => !!v || this.$t('required')]
  },
  mounted () {
    if (this.isEdit) {
      this.course = {
        id: this.editCourse.id,
        title: this.editCourse.title,
        code: this.editCourse.code,
        courseTitleKG: this.editCourse.courseTitleKG,
        classType: this.editCourse.classType
      }
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        if (this.isEdit) {
          adminCourseService.edit(this.course).then(() => {
            this.$toast.success(this.$t('successfulUpdate'))
            this.$emit('close')
            this.isLoading = false
          }).catch((err) => {
            this.$toast.error(err)
            this.isLoading = false
          })
        } else {
          adminCourseService.create(this.course).then(() => {
            this.$toast.success(this.$t('successfulCreate'))
            this.$emit('close')
            this.isLoading = false
          }).catch((err) => {
            this.$toast.error(err)
            this.isLoading = false
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-form {
    background: #FFFFFF;
    border-radius: 7px;
    padding: 20px 40px;

    div.form-head {
        display: flex;
        justify-content: space-around;
    }
}
</style>
